var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeClockCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time-clock-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-03",
    transform: "translate(-864.000000, -440.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(300.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(40.000000, 237.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(460.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time-clock-circle",
    transform: "translate(64.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,15.5 C3.86466667,15.5 0.5,12.1353333 0.5,8 C0.5,3.86466667 3.86466667,0.5 8,0.5 C12.1353333,0.5 15.5,3.86466667 15.5,8 C15.5,12.1353333 12.1353333,15.5 8,15.5 Z M8,1.5 C4.416,1.5 1.5,4.416 1.5,8 C1.5,11.584 4.416,14.5 8,14.5 C11.584,14.5 14.5,11.584 14.5,8 C14.5,4.416 11.584,1.5 8,1.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1246667,11.6253333 C10.9913333,11.6253333 10.8653333,11.5733333 10.7713333,11.4786667 L7.64666667,8.35333333 C7.6,8.30666667 7.56333333,8.252 7.538,8.19 C7.536,8.18466667 7.534,8.17866667 7.532,8.17333333 C7.51066667,8.116 7.50066667,8.05866667 7.50066667,8 L7.50066667,5.5 C7.50066667,5.224 7.72466667,5 8.00066667,5 C8.27666667,5 8.50066667,5.224 8.50066667,5.5 L8.50066667,7.79266667 L11.4786667,10.7713333 C11.5733333,10.866 11.6253333,10.9913333 11.6253333,11.1246667 C11.6253333,11.258 11.5733333,11.384 11.4786667,11.478 C11.384,11.572 11.258,11.6253333 11.1246667,11.6253333 Z",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockCircle);
export default __webpack_public_path__ + "static/media/time-clock-circle.20204c7ad5d9f425d0955203447fe11f.svg";
export { ForwardRef as ReactComponent };